import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8638d958"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "tabs" };
const _hoisted_3 = { class: "tab_rows" };
const _hoisted_4 = {
    class: "tab_row",
    for: "orders"
};
const _hoisted_5 = {
    class: "tab_row",
    for: "balance"
};
const _hoisted_6 = { class: "tab_content" };
import MyOrder from './MyOrder.vue';
import Balances from './Balances.vue';
import Loading from '@/materials/molecules/Loading.vue';
import { ref } from 'vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean },
        userInfo: null,
        pair: null,
        base: null,
        quote: null
    },
    setup(__props) {
        const props = __props;
        const { format, BALANCES_TITLES, SMART_PHONE_ORDER_FIELDS } = useMessage();
        const showContent = ref('orders');
        const switchContent = (content) => {
            showContent.value = content;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("input", {
                            id: "orders",
                            type: "radio",
                            name: "tab_item_under",
                            onClick: _cache[0] || (_cache[0] = ($event) => (switchContent('orders'))),
                            checked: ""
                        }),
                        _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(format)(_unref(SMART_PHONE_ORDER_FIELDS).TITLE)), 1),
                        _createElementVNode("input", {
                            id: "balance",
                            type: "radio",
                            name: "tab_item_under",
                            onClick: _cache[1] || (_cache[1] = ($event) => (switchContent('balance')))
                        }),
                        _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(format)(_unref(BALANCES_TITLES).TITLE)), 1)
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: "tab_content",
                        key: props.pair
                    }, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(MyOrder, {
                                    isAuth: props.isAuth,
                                    userInfo: props.userInfo,
                                    pair: props.pair,
                                    base: props.base,
                                    quote: props.quote
                                }, null, 8, ["isAuth", "userInfo", "pair", "base", "quote"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ])), [
                        [_vShow, showContent.value === 'orders']
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_6, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(Balances, {
                                    isAuth: props.isAuth,
                                    userInfo: props.userInfo
                                }, null, 8, ["isAuth", "userInfo"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ], 512), [
                        [_vShow, showContent.value === 'balance']
                    ])
                ])
            ]));
        };
    }
});
